export default __webpack_public_path__ + "static/media/060_corner2.vp9.a3be4b9d.webm";